import Vue from 'vue';
import { api } from "../../services/Api.js";

export function get_absence_reasons({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // make api call
    return api
    .post(school,"get_absence_reasons.php",payload)
    .then( result =>{
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: get_absence_reasons: "+error);
      return error;
    })

   
    
  }